module.exports = __webpack_public_path__ + "img/EASTEA_LOGO_LOGIN.1b818507.jpeg";